import { replace } from 'react-router-redux';
import getTagByTitle from '../redux/actions/get-tag-by-title';
import urlFriendly from './url-friendly';

export default async function redirectToCollectionByTitle({ dispatch, title }) {
    const response = await dispatch(getTagByTitle({ title, force: true }));

    if (!response) {
        return;
    }

    const { tag } = response.payload;
    if (!tag) {
        return;
    }

    await dispatch(replace(`/tag/${tag.id}/${urlFriendly(tag.title)}`));
}



/** WEBPACK FOOTER **
 ** ./src/utils/redirect-to-collection-by-title.js
 **/